<template>
  <div class="work-space">
    <div class="all-loadPage" v-show="loadingData">
      <div class="img-loading">
        <img src="../assets/images/loading.gif">
        <div class="load-size"><b>{{$t('language.common.load')}}<span class="dotting"></span></b></div>
      </div>
    </div>
    <div v-show="!loadingData" style="width:100%;height:100%;">
      <div class="beginGuideFlag" v-if="$store.state.beginGuideFlag"></div>
      <leftBanner ref="leftBanner"></leftBanner>
      <div class="right-larg-body">
        <rightContBan ref="rightContBan"></rightContBan>
        <keep-alive include="taskList">
        <router-view ref="routView"></router-view>
         </keep-alive>
      </div>
      <changePasswordDialog ref="changePass"></changePasswordDialog>
      <bindEmailDialog ref="bindEmail"></bindEmailDialog>
      <changeNameDialog ref="changeName"></changeNameDialog>
      <deleteAccountDialog ref="deleteAccount"></deleteAccountDialog>
      <deleteAccountRemindDialog ref="deleteAccountRemindDialog"></deleteAccountRemindDialog>
      <subAccountDialog ref="subAccount"></subAccountDialog>
      <limitedSaledDialog ref="limitedSaledDialog"></limitedSaledDialog>
      <!-- <summerSaledDialog ref="summerSaledDialog"></summerSaledDialog> -->
      <halloweenSaleDialog ref="halloweenSaleDialog"></halloweenSaleDialog>
      <payDiffDialog ref="payDiffDialog"></payDiffDialog>
      <iosPayTipDialog ref="iosPayTipDialog"></iosPayTipDialog>
      <appRecommendDialog ref="appRecommendDialog"></appRecommendDialog>
      <appRecommendMobileDialog ref="appRecommendMobileDialog"></appRecommendMobileDialog>
    </div>
  </div>
</template>

<script>
import leftBanner from '@/components/common/left_banner.vue';
import rightContBan from '@/components/common/right_top_banner';
import addCloud from '@/components/workspace/add_cloud';
import cloudExploer from '@/components/workspace/cloud_exploer';
import preview from '@/components/workspace/preview';
import cloudTransfer from '@/components/workspace/cloud_transfer';
import cloudSnyc from '@/components/workspace/cloud_sync';
import remoteTask from '@/components/workspace/remote_task';
import taskList from '@/components/workspace/task_list';
import paySys from '@/components/workspace/pay_system';
import deleteAccountRemindDialog from '@/components/popup/personal_center_popups/delete_account_remind_popup';
import changePasswordDialog from '@/components/popup/personal_center_popups/change_password_popup';
import changeNameDialog from '@/components/popup/personal_center_popups/change_name_popup';
import bindEmailDialog from '@/components/popup/personal_center_popups/bind_email_popup';
import deleteAccountDialog from '@/components/popup/personal_center_popups/delete_account_popup';
import halloweenSaleDialog from '@/components/popup/upgrade_popups/limited_halloween_saled_popup';
import payDiffDialog from '@/components/popup/pay_system_popups/pay_diff_money_popup';
import homePage from '@/components/workspace/home';
import commonstate from '@/js/constant.js';
import taskListUtils from "@/js/workspace/task_list_util.js";
import commonUtils from "@/js/workspace/common_util.js";
import addCloudUtils from "@/js/workspace/add_cloud_utils.js";
import subAccountDialog from "@/components/popup/sub_account_popups/sub_account_popup";
// import limitedSaledDialog from '@/components/popup/upgrade_popups/time_limited_saled_popup';
// import limitedSaledDialog from '@/components/popup/upgrade_popups/summer_saled_popup';
import limitedSaledDialog from '@/components/popup/upgrade_popups/flash_saled_popup';
// import limitedSaledDialog from '@/components/popup/upgrade_popups/countdown_saled_popup';
import googleAnalyticsUtil from "@/js/workspace/google_analytics_util.js";
import upgradeItemUtils from '@/js/workspace/upgrade_item.js';
import christmasSaledDialog from '@/components/popup/upgrade_popups/christmas_saled_popup';
import iosPayTipDialog from '@/components/popup/pay_system_popups/ios_pay_tip_popups';//ios提示用户当前有订阅弹窗
import appRecommendDialog from '@/components/popup/activity_popups/app_recommend_popup';//web端app推荐弹窗
import appRecommendMobileDialog from '@/components/popup/activity_popups/app_recommend_mobile_popup';//手机端app推荐弹窗
import constant from '../js/constant';
export default {
  data () {
    return {
      loadingData: true,
      taskListFlag: false,//用于标识任务列表是否加载完毕
      allCloudListFlag: false,//用于标识添加云盘列表是否加载完毕
      unavailCloud: ['facebook', 'goDaddy', 'copy', 'team', 'picasa', 'ubuntu', 'youtube', 'bitcasa', 'apple'],
      clickCurrent:-1,
      menuClickCurrent:-1,
      spliceFlag:5,//用于标志分组的下标
      allDrivesArr:[],
      allLoadDrivesArr:[],
      allDrivesArrCopy:[],
    }
  },
  components: {
    leftBanner,
    rightContBan,
    addCloud,
    cloudExploer,
    preview,
    cloudTransfer,
    cloudSnyc,
    taskList,
    paySys,
    changePasswordDialog,
    changeNameDialog,
    bindEmailDialog,
    deleteAccountDialog,
    remoteTask,
    homePage,
    deleteAccountRemindDialog,
    subAccountDialog,
    limitedSaledDialog,
    // summerSaledDialog,
    halloweenSaleDialog,
    payDiffDialog,
    iosPayTipDialog,
    appRecommendDialog,
    appRecommendMobileDialog,
  },
  created () {
    let that=this;
    commonUtils.refreshUserInfo(this,function(res){
    let user = commonUtils.getUser();
     //如果用户不是无限年不是终身无限
    if(user.payType!='Lifetime'){
      commonUtils.getUserSchemeForPsySys(user.id);//初始化页面
    }
    if(user.vip){
        if(!(user.payLevel==1&&user.payType=='Yearly')&& user.payType!='Lifetime'){
            upgradeItemUtils.getItemPreview(null,function(res){
               let  direction = window.vm.$children[0].$refs.routerView.$refs.routView;
                if(that.$route.name=='paySys'){
                      if (!direction.morePrivileges) {
                          direction.initShowData();
                         }
                }
            });
            upgradeItemUtils.getItemPreview('activity',function(res){
               let  direction = window.vm.$children[0].$refs.routerView.$refs.routView;
                if(that.$route.name=='paySysActivity'){
                      if (!direction.morePrivileges) {
                          direction.initShowData();
                         }
                }
            });
            // upgradeItemUtils.getItemPreview('halloween',function(result){
            //         that.$refs.rightContBan.showHalloweenFunnel('sure');
            // });
        }
    }
    });//刷新用户流量
    //获取用户标签信息
    commonUtils.getAllActiveTagByUser();
  },
  watch: {
    //监听云盘类型
    '$store.state.cloudCategories': function (newValue, oldValue) {
      if (newValue.length) {
        commonstate.cloudCategories = newValue;
        this.groupCategories();
      }
    },
    //判断任务列表是否加载完毕，若云盘列表也加载完毕则取消loading加载效果
    '$store.state.taskListFlag': function (newValue, oldValue) {
      if (newValue && this.allCloudListFlag) {
        this.loadingData = false;
      }
    },
    //如果云盘列表加载完毕,判断任务列表是否加载完毕，若任务列表也加载完毕则取消loading加载效果
    allCloudListFlag (newValue, oldValue) {
      let that = this;
      if (newValue) {
          //如果没有云盘列表和选中的选项
          if(!this.$refs.leftBanner.clouds.length&&this.clickCurrent==-1&&(this.menuClickCurrent==-1)){
             this.$refs.leftBanner.menuOptionSelect(10);
          }
        if (this.$store.state.taskListFlag) {
          that.loadingData = false;
        }
      }
    },
    //全局监听未分组的数据
    '$store.state.taskListNotGropArr': function (newValue, oldValue) {
      if (newValue.length) {
        //消除原有分组数据的影响
         let newValueCopy = Object.assign([], newValue);
        $.each(newValueCopy, function (i, item) {
          if(item.branchType!='businessTransfer'){
          delete item.sources;
          }
        });
        newValueCopy.sort(taskListUtils.sortCreateTime);
        let allTaskListArr = taskListUtils.constructGroupData(newValueCopy);
        allTaskListArr.sort(taskListUtils.sortCreateTime);
        this.$store.commit('setTaskListArrAll', allTaskListArr);
      }
    },//监听加载界面
    loadingData(newValue, oldValue){
    if(!newValue){//如果loading界面不显示，调用方法判断临时账号是否显示
        this.$refs.rightContBan.judgeHaveNewNotifications();
        var ud = commonUtils.getUser().id;
        var notice = localStorage.getItem(ud+'noticeShow');
        if(notice && notice!="undefined" ){
                var length= localStorage.getItem(ud+'driveNum');//用户的云盘列表长度
                var allDrives = Object.assign([], this.$store.getters.getUsersDrives);
         if(length == allDrives.length){
              this.$toast({
                text: this.$t('language.exception.alreadyAdd'),
                type: 'fail',
                idValue: "rightContBan"
            });
         }
        }
        localStorage.removeItem(ud+'noticeShow');
        localStorage.removeItem(ud+'driveNum');
    }
    },
    allLoadDrivesArr(newValue, oldValue){
      if(this.allDrivesArrCopy.length){
          let that = this;
          let newArr = Object.assign([],newValue);
          let newSingle = newArr[newArr.length - 1];
          $.each(this.allDrivesArrCopy,function(i,item){
                if(item.id == newSingle.id){
                    that.allDrivesArrCopy[i] = newSingle;
                    that.$store.commit("setUsersDrives",that.allDrivesArrCopy);
                    return;
                }
          });
      }
    }
  },
  mounted () {
    let that = this;
    let user=commonUtils.getUser();
    this.sendGAEvent(user);
    let password;
    if(user.password){
    password=user.password;
    }
    commonUtils.refreshUserInfo(this.$refs.leftBanner,function(res){
    if(password){
    user=res;
    user.password=password;
    localStorage.setItem("user", JSON.stringify(user));
    that.$cookies.set("user",JSON.stringify(user),"7d");
    }
    });
     this.clickCurrent = parseInt(Base64.decode(localStorage.getItem("leftbannerClick"+user.id)));
     this.menuClickCurrent = parseInt(Base64.decode(localStorage.getItem("leftbannerMenuClick"+user.id)));
	 if (!user.loginTime&&this.clickCurrent==-1&&(this.menuClickCurrent==-1|| isNaN(this.menuClickCurrent))) {
         this.$refs.leftBanner.menuOptionSelect(10);
        }
    this.initDrives();
    this.$i18n.locale = localStorage.getItem('locale') || 'english';
    if(this.$i18n.locale == 'english'){
        localStorage.setItem('locale','english');
    }
  },
  methods: {
    //进入界面初始化数据
    initDrives () {
      let that = this;
      let toggleWhileEditing = that.$route.query.toggleWhileEditing;
      let user = commonUtils.getUser();
      this.$refs.leftBanner.clouds = this.Utils.getAllCloudsList(function (res) {
        that.allCloudListFlag = true;
        //判断是否是添加的已存在云盘，是进行提示
        if(that.$route.query.isAlready){
          that.$toast({
            text: that.$t('language.exception.alreadyAdd'),
            type: 'fail',
            idValue: 'rightContBan',
          });
        }
          //判断编辑云盘是否更换了云盘账号
          if (toggleWhileEditing) {
              const newLocal = "language.exception.toggleWhileEditing";
              that.$toast({
                text: that.$t(newLocal),
                type: "fail2",
                idValue: "allBox",
              });
            }
        if (res.status == 200) {
          if (that.$refs.routView.clouds && !that.$refs.routView.clouds.length && that.$refs.leftBanner.clouds.length) {
            that.$refs.routView.clouds = that.$refs.leftBanner.clouds;
          } else {
            if (that.$route.query && that.$route.query.tokenId && that.$route.query.folderId != 'recycle_bin' && !that.$store.state.retryItems.length) {
              that.$refs.leftBanner.getLeftOption(that.$route.query.tokenId);
            }
          }
          let newValue = that.$refs.leftBanner.clouds;
          that.allDrivesArr = Object.assign([],newValue);
          that.allDrivesArrCopy = Object.assign([],newValue);
          that.$store.commit("setUsersDrives", newValue);
          that.splicedriveArr();
          let progrssData = {
            ud: user.id,
            type: 4
          }
          that.Utils.doTasksRequest("list_running_tasks", progrssData).then(res => {
            if (res.states && res.states.length) {
              res.states = res.states.reverse();
              that.$store.state.listRuningData = res.states;
               if(res.states[0].desCloudType=='team'){
                  return;
              }
              if(that.$refs.leftBanner&& that.$refs.leftBanner.getOption){
              that.$refs.leftBanner.getOption(res.states[0].desToken);
              }
            that.menuClickCurrent = -1;
            if(that.$refs.leftBanner&& that.$refs.leftBanner.getMenuOption){
               that.$refs.leftBanner.getMenuOption();
               }
            } else {
              that.$store.state.listRuningData = [];

            }
          });
        } else {
          that.$toast({
            text: that.$t('language.exception.' + res.reason),
            type: 'fail',
            idValue: "allBox"
          });
        }
      }, err => {
        this.$toast({
          text: err,
          type: 'fail',
          idValue: "allBox"
        });
      });
     // if (that.$route.name != 'cloudTransfer' && that.$route.name != 'cloudSync') {
        taskListUtils.inintTaskList(function (res) {
          that.$store.state.taskListFlag = true;
        });
      //}
      that.groupCategories();
    },
    packageAimPath(data){
        let desNodeArr=data.desNode;
        let pathJsonArr=[];
        for(let i=desNodeArr.length-1;i>=0;i--){
            //防止出现重复的nodes
              if(i<desNodeArr.length-1&&desNodeArr[i].filename==desNodeArr[i+1].filename &&desNodeArr[i].fileId==desNodeArr[i+1].fileId){
                  return;
              }
              let pathJson = {
					id: desNodeArr[i].fileId,
					name: desNodeArr[i].filename,
					driveId:  data.desToken
				}
            pathJsonArr.push(pathJson);
            let JsonList = Object.assign([], pathJsonArr);
             this.$store.commit("setPathJson", {
				folderId: desNodeArr[i].fileId +  data.desToken,
				json: JsonList
			});
        }

    },
    sendGAEvent(user){
     // 网站部新版主页GA记录
     googleAnalyticsUtil.home(this);
     // 用户通过免登陆或三方登录时，开发部GA打点记录
     let isNewWindow = sessionStorage.getItem("user") == null;
     let thirdLogin = sessionStorage.getItem("thirdLogin") != null;
      if(isNewWindow || thirdLogin){//相当于重新登录删除弹窗已显示标志
        if(isNewWindow){
        localStorage.removeItem('timeSale'+user.id);
        }
        if(!user.loginType || user.loginType=="sub" || commonstate.activeLoginTypeList.includes(user.loginType) || commonstate.channelTypeList.includes(user.loginType)){
            this.getLoginTime();
         }else{
           //判断显示漏斗和自动弹窗
              this.$refs.rightContBan.showFunnel();
         }
        googleAnalyticsUtil.login(this, user);
      }else{
        this.$refs.leftBanner.judgeGuideSHow();//判断是否显示新手引导界面
      }
    },
    //将云盘数组进行分组
    splicedriveArr(){
        let that = this;
        setTimeout(()=>{
        let newDrivesArr = that.allDrivesArr.splice(0,that.spliceFlag);
             that.getDriveInfo(newDrivesArr);
        },200);

    },
    //获取用户的登录时间
    getLoginTime(){
        let that = this;
        let user = commonUtils.getUser();
        let getData={
              ud: user.id,
              salt:user.salt,
              language: commonUtils.getLocaleTo(localStorage.getItem("locale")),
        }
        //是否是信任设备
        var tdJson = localStorage.getItem("trustedDevice");
        if(tdJson){
            var td = JSON.parse(tdJson)[user.email];
            if(td){
                getData.tdcode = td;
            }
        }
        this.Utils.doUserHaveLoginRequest("direct_sign_in",getData).then(res=>{
              if(res.status==200){
              localStorage.setItem("user",JSON.stringify(res.user));
              that.$cookies.set("user",JSON.stringify(user),"7d");
              sessionStorage.setItem("user", JSON.stringify(res.user));
              that.$refs.leftBanner.judgeGuideSHow();//判断是否显示新手引导界面
              //判断显示漏斗和自动弹窗
              that.$refs.rightContBan.showFunnel();
              //每一次都重新检测
              //localStorage.removeItem('halloweenSale'+user.id);
              //that.$refs.rightContBan.showHalloweenFunnel();
              }else{
                this.$toast({
                  text: that.$t('language.exception.autoLoginFail'),
                  type: 'fail',
                  idValue: "allBox"
                });
              }
        });
    },
    getDriveInfo(drivesArr){
      let that=this;
      for(let i=0;i<drivesArr.length;i++){
                let getData=new addCloudUtils.getData(commonUtils.getUser().id,drivesArr[i].id);
                drivesArr[i].isRotate=true;
                that.Utils.doDrivesRequest("get", getData).then(res => {
                    drivesArr[i].isRotate=false;
                    drivesArr[i].haveLoad=true;//表示该数据已经加载
                    if (res.status == 200) {
                    drivesArr[i].driveInfo.totalSpace = res.drive.totalSpace;
                    drivesArr[i].driveInfo.usedSpace = res.drive.usedSpace;
                    that.$forceUpdate();
                    }
                     that.allLoadDrivesArr.push(drivesArr[i]);
                     if(i == drivesArr.length-1){
                        that.splicedriveArr();
                    }
                },err=>{
                     if(i == drivesArr.length-1){
                        that.splicedriveArr();
                    }
                   });
                setTimeout(()=>{
                  drivesArr[i].isRotate=false;
                  drivesArr[i].haveLoad=true;
                },15000);//只要超过10秒就将数据加载设为已加载，
              }
    },
    groupCategories () {
      let that = this;
      //获取云盘种类并存储在store中
      let addCloudLineUp = [];
      let addCloudLineDown = [];
      let allCategories = [];
      let CategoriesAll = commonstate.cloudCategories;
      let jsonTargetUp = [];
      let jsonTargetDown = [];
      CategoriesAll = CategoriesAll.filter(cloud => commonstate.emailClouds.includes(cloud.driveType));
      for(var i=0;i<CategoriesAll.length;i++){
        var item = CategoriesAll[i];
        if (!item.bussiness ) {
          if (!that.unavailCloud.includes(item.appName) && item.appName != 'amazon') {
            jsonTargetUp.push(item);
          }
        } else  {
          jsonTargetDown.push(item);
        }
      }
      addCloudLineUp = jsonTargetUp.sort(sortDown);
      addCloudLineDown = jsonTargetDown.sort(sortDown);
      allCategories = addCloudLineUp.concat(addCloudLineDown);
      this.$store.commit('setAddCloudLineUp', jsonTargetUp);
      this.$store.commit('setAddCloudLineDown', jsonTargetDown);
      this.$store.commit('setAllCategories', addCloudLineUp.concat(addCloudLineDown));
    },
  }
}
function sortDown (x, y) {
  return y.level - x.level;
}
</script>

<style>
.work-space {
  width: 100%;
  height: 100%;
}

.right-larg-body {
  width: calc(100% - 250px);
  /*no*/
  margin-left: 250px;
  /*no*/
  height: 100%;
  position: relative;
  min-width: 1200Px;
}

.all-loadPage {
  width: 100%;
  height: 100%;
  background-color: #e6eaf9;
  position: relative;
}

.img-loading {
  margin: auto;
  position: fixed;
  width: 600px;
  /*no*/
  height: 200px;
  /*no*/
  top: -30%;
  bottom: 0;
  left: 0;
  right: 0;
}

.load-size {
  font-size: 19px;
  /*no*/
  text-align: center;
  color: #565656;
  font-family: sans-serif;
}

.dotting {
  font-family: sans-serif;
  display: inline-block;
  width: 20px; /*no*/
  min-height: 4px; /*no*/
  padding-right: 4px; /*no*/
  border-left: 4px solid currentColor; /*no*/
  border-right: 4px solid currentColor; /*no*/
  background-color: currentColor;
  background-clip: content-box;
  box-sizing: border-box;
  -webkit-animation: dot 4s infinite step-start both;
  animation: dot 1s infinite step-start both;
}

.dotting:before {
  font-family: sans-serif;
  content: '...';
}

/* IE8 */
.dotting::before {
  font-family: sans-serif;
  content: '';
}

:root .dotting {
  margin-left: 4px; /*no*/
  padding-left: 4px; /*no*/
}

/* IE9+ */

@-webkit-keyframes dot {
  25% {
    border-color: transparent;
    background-color: transparent;
  }

  50% {
    border-right-color: transparent;
    background-color: transparent;
  }

  75% {
    border-right-color: transparent;
  }
}

@keyframes dot {
  25% {
    border-color: transparent;
    background-color: transparent;
  }

  50% {
    border-right-color: transparent;
    background-color: transparent;
  }

  75% {
    border-right-color: transparent;
  }
}

.beginGuideFlag {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 200;
}
</style>



// WEBPACK FOOTER //
// src/components/mc_project.vue